<template>
  <div class="vParameter" style="padding: 2rem;">
    <b-form @submit="onSubmit"  @reset="onReset" style="text-align:left;"
      v-if="null != inpData">
      <b-form-group
        id="input-group-1"
        label="學年度："
        label-for="input-1">
        <b-form-input style="width:10rem;"
          id="input-1" type="number"
          v-model="inpData.schYY[0].codeName"
          @change="inpData.schYY[0].status='C'"
          placeholder="請輸入學年度..." min="1" max="200"
          required></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-2" v-slot="{ ariaDescribedby }"
        label="學期："
        label-for="input-2">
        <b-form-radio-group
          id="btn-radios-2"
          v-model="inpData.smt[0].codeName"
          @change="inpData.smt[0].status='C'"
          :options="options"
          :aria-describedby="ariaDescribedby"
          button-variant="outline-primary"
          placeholder="請輸入學期..."
          name="radio-btn-outline"
          buttons
        ></b-form-radio-group>
      </b-form-group>
      <b-button style="margin: 1rem 1.5rem;" type="submit" variant="success">{{$t('message.Save_cmd')}} <b-icon icon="check"/></b-button>
    </b-form>
  </div>
</template>

<script>
import * as tools from '@/tool'
export default {
  name: 'vCode',
  data () {
    return {
      inpData: null,
      options: [
        { text: '上學期', value: '1' },
        { text: '下學期', value: '2' }
      ]
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    }
  },
  methods: {
    checkSaveData () {
      var tCount = 0
      for (var label in this.inpData) {
        var sLen = (tools.isNull(this.inpData[label]) ? 0 : this.inpData[label].length)
        for (var i = 0; i < sLen; i++) {
          var obj = this.inpData[label][i]
          if (tools.isNullOrWhiteSpace(obj.codeName)) {
            return '設定內容空白'
          }
          if ((obj.status == 'A') || (obj.status == 'C') || (obj.status == 'R')) {
            tCount++
          }
        }
      }

      return (tCount > 0 ? '' : '無異動資料')
    },
    onSubmit (event) {
      event.preventDefault()
      var vm = this
      const msg = this.checkSaveData()
      if (msg.length === 0) {
        var vm = this
        var inpObj = {
          sysId: this.sysId,
          schYY: this.inpData.schYY,
          smt: this.inpData.smt
        }
        this.$http.put('./WebApi/Setting/SetCodeData', inpObj)
          .then((response) => {
            if (response.data) {
              tools.showAlert(vm, 'success', '恭喜您,存檔成功')
              vm.getTypeList()
            } else {
              tools.showAlert(vm, 'danger', '對不起,存檔失敗')
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, 'danger', '網路連線失敗' + error)
          })
      } else {
        tools.showAlert(this, 'danger', '對不起,' + msg)
        return false
      }
    },
    onReset (event) {
      event.preventDefault()
    },
    getTypeList: function () {
      var vm = this
      this.$http
        .get('./WebApi/Setting/GetTypeList/'.concat(this.sysId))
        .then(function (response) {
          vm.inpData = response.data
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗' + error)
        })
    }
  },
  created () {
    // console.log('=== created ParameterView ===');
    this.getTypeList()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
	-webkit-appearance: none;
}
</style>
